import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { sendTrace, sendMetric, logInfo } from "../Utils/otelClient";

export const useAutoPageTracing = () => {
  const location = useLocation();
  const startRef = useRef(Date.now());

  useEffect(() => {
    const end = Date.now();
    const loadTime = end - startRef.current;
    
    // Enhanced navigation logging with more detailed message including URL
    const sessionId = sessionStorage.getItem('otel_session_id') || 'unknown';
    const browser = navigator.userAgent.includes('Chrome') ? 'Chrome' : 
                   navigator.userAgent.includes('Firefox') ? 'Firefox' : 
                   navigator.userAgent.includes('Safari') ? 'Safari' : 'Unknown';
    
    const currentUrl = window.location.href;
    const urlParts = new URL(currentUrl);
    const baseUrl = `${urlParts.protocol}//${urlParts.host}`;
    const queryParams = location.search ? `?${location.search.slice(1)}` : '';
    const viewport = `${window.innerWidth}x${window.innerHeight}`;
    
    const detailedMessage = `Page Navigation: ${location.pathname}${queryParams} | Host: ${urlParts.host} | Load: ${loadTime}ms | Session: ${sessionId.slice(0, 8)} | Browser: ${browser} | Viewport: ${viewport} | From: ${getPreviousPath()}`;
    
    logInfo(detailedMessage, [
      { key: "event.type", value: { stringValue: "page_navigation" } },
      { key: "page.path", value: { stringValue: location.pathname } },
      { key: "page.search", value: { stringValue: location.search } },
      { key: "page.hash", value: { stringValue: location.hash } },
      { key: "navigation.load_time_ms", value: { stringValue: String(loadTime) } },
      { key: "navigation.previous_path", value: { stringValue: getPreviousPath() } },
      { key: "user.interaction", value: { stringValue: "route_change" } },
    ]);

    sendTrace(`Route: ${location.pathname}`, startRef.current, end, [
      { key: "path", value: { stringValue: location.pathname } },
      { key: "load_time_ms", value: { stringValue: String(loadTime) } },
    ]);

    sendMetric("page_view", 1, [
      { key: "path", value: { stringValue: location.pathname } },
      { key: "load_time_ms", value: { stringValue: String(loadTime) } },
    ]);
    
    // Store current path for next navigation
    sessionStorage.setItem('previous_path', location.pathname);
    startRef.current = Date.now();
  }, [location.pathname]);
};

// Helper function to get previous path
const getPreviousPath = (): string => {
  return sessionStorage.getItem('previous_path') || 'initial_load';
};
